import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentBG = () => {
    return <Aux>
        <SectionHeading priority={1} text='Материали' />
        <p><b>Дограма - REHAU GENEO</b> - НАЙ-ДОБРАТА ДОГРАМА, КОЯТО ВСЕКИ ЗАСЛУЖАВА!</p>
        <p>GENEO, е лидер при луксозното строителство. Системата е патентована от REHAU с използването на нова технология, при която средната камера на профилите се екструдира (отлива на матрица) от високотехнологичния материал RAU-FIPRO. Този високотехнологичен материал за първи път се използва в самолетостроенето и във Формула 1, а сега вече и в дограмата.<br />
            GENEO – лидерът сред 86-милиметровите системи! Това е перфектната комбинация от 7-камерни каси с 6-камерни крила и надлъжно вградени, средни гумени уплътнения<br />
            Троен стъклопакет: 4 мм.ка +4 мм.бяло + 4мм.четири сезона 42 мм.<br />
            Стъклопакетите се заливат с двукомпонентен полисулфид на Кьомерлинг- Германия<br />
            Оригинално Уширение 45/80 Synego  зад всяко крило от към пантите – Подготовка за монтаж на вътрешни щори</p>
        <p><b>Технически детайли:</b><br />
            Монтажна ширина – 86мм. <br />
            Допълнително надлъжно средно гумено уплътнение<br />
            Средна камера изработена от специални стъклофибърни нишки<br />
            Опция за вграждане на специални термични профили<br />
            Коефициент на топлопреминаване на профила Uf = 1.0 W/m²K<br />
            Защита от шум – до клас на шумозащита 5<br />
            Защита от взлом – до клас на съпротивление 3</p>
        <p><b>Обков</b> - <i>activPilot</i> e последно поколение обковна система на <i>Winkhaus</i>, съчетаващ най-съвременен дизайн и висока функционалност</p>
        <p>activPilot е единствената обковна система за двуосово отваряне на пазара, доставянa стандартно във вариант на повишена степен на сигурност (RC1/RC2 и от скоро - RC3).
Всички елементи по крилото на прозореца сa със секюрити точки на заключване с „гъбовидна“ форма. По-високи степени на сигурност (RC1/WK1, RC2/WK2 или RC3/WK3) се постигат само чрез подмяната на насрещниците от обикновени със секюрити такива.</p>
        <p><b>Дръжки</b> – модел разработен  от Пининфарина, прочутият дизайнер.</p>
        <p><b>Тухли</b> – Porotherm на Wienerberger.<br />
            Материал с традиции, но отговарящ на съвременните изисквания</p>
        <ul>
            <li>Естествена топлоизолация и климатизация</li>
            <li>Звукоизолация</li>
            <li>Пожарозащита</li>
            <li>Здравина</li>
            <li>Микроклимат</li>
            <li>Ниска равновесна влажност</li>
            <li>Екологичност</li>
            <li>Дълготрайност</li>
        </ul>
        <p><b>Топлоизолация и хидроизолация</b> - от най-висок клас</p>
        <p><b>Парапети</b> - високоякостно ламинирано стъкло</p>
        <p><b>Външна врата</b> - висок клас входни врати – блиндирани</p>
    </Aux>
}

export default ContentBG



// WEBPACK FOOTER //
// ./src/routes/Materials/components/ContentBG.js